import React, { useState, useEffect } from 'react';
import { useSpring, animated, config } from 'react-spring';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'hooks/useLocalStorage';

interface Props {}

export const Cookie: React.FC<Props> = () => {
    const { t } = useTranslation();
    const hasWindow = typeof window !== 'undefined' ? true : false;
    const [cookieActive, cookieSetActive] = useState<boolean>(false);
    const [localStorageData, setLocalStorageData] = useLocalStorage('cookie', '');
    const cookieProps = useSpring({
        y: cookieActive ? 0 : 100,
        config: config.wobbly,
    });

    useEffect(() => {
        // eslint-disable-next-line curly
        if (!hasWindow || localStorageData) return;
        cookieSetActive(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasWindow]);

    const cookieHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        cookieSetActive(false);
        setLocalStorageData('true'); // Replace with cookie settings (user options)
    };

    return (
        <animated.div className="am_cookie_container" style={cookieProps}>
            <div className="am_cookie_content">
                <div className="am_cookie_text">
                    <p>🍪</p>
                    <p>{t('cookie.content')}</p>
                </div>
                <div className="am_cookie_close" onClick={cookieHandler}>
                    x
                </div>
            </div>
        </animated.div>
    );
};
